export const mutations={
    setClientSize(state,size){
        state.height = size.height
        state.width = size.width
    },
}